<template>
    <!-- If still loading, show an engaging skeleton loader + message -->
    <div v-if=" isLoading || !searchResults" class="flex flex-col items-center my-4 space-y-3">
      
      <!-- Playful text: you can tweak the messaging or animation -->
      <p class="text-sm text-gray-500 animate-pulse">
        正在检索此区域内的医生，请稍等片刻...
      </p>
      
      <!-- Skeleton loader: repeat a certain number of placeholders -->
      <div v-for="n in 4" :key="n" class="w-full p-4 rounded-lg shadow-sm bg-white">
        <div class="animate-pulse flex space-x-4">
          <div class="rounded-full bg-gray-300 h-10 w-10"></div>
          <div class="flex-1 space-y-2 py-1">
            <div class="h-4 bg-gray-300 rounded w-3/4"></div>
            <div class="h-4 bg-gray-300 rounded w-1/2"></div>
          </div>
        </div>
      </div>
    </div>
  
    <!-- If not loading, show the real doctor list -->
    <div v-else>
      <div
        v-for="(doctor, index) in searchResults"
        :key="index"
        class="mt-1"
      >
        <DoctorListCard
          :doctor_object="doctor"
          :index="index"
          @mouseover="updateHoverAt(index)"
        />
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue'
  import useSearch from '~/composables/useSearch'
  
  // Access composable for searching
  const { searchQuery, searchResults, getSearchResults, listFocusIndex } = useSearch()
  
  // State to track loading
  const isLoading = ref(false)
  
  onMounted(async () => {
    // Start loading
    isLoading.value = true
    
    // Simulate fetching (or actually fetch) your search results
    // The user specifically said ~5 seconds, so we'll mimic that here:
    await getSearchResults('')
    
    // Or you could do: 
    // await new Promise(resolve => setTimeout(resolve, 5000))
    // if you want a forced 5s wait
    
    // Once data arrives, switch off loading
    setTimeout(() => {
      isLoading.value = false
    }, 800)
  })
  
  // Called on mouseover for the item
  function updateHoverAt(index) {
    listFocusIndex.value = index
  }
  </script>
  
  <style scoped>
  /* Optional: style your skeleton or text more elaborately. */
  </style>
  